<template>
  <div>
    <section id="detail-info">
      <b-row class="section_row">
        <b-col cols="4" v-show="active === 0">
          <div class="energy">
            <h4>能耗统计</h4>
            <div class="energy_content">
              <div class="energy_row">
                <div class="energy_item">
                  <span> 电力总容量 {{ 1000 }} KW </span>
                </div>
                <div class="energy_item">
                  <span> 当前总用电量 {{ 1000 }} KW </span>
                </div>
              </div>
              <div class="energy_row">
                <div class="energy_item">
                  <span> IT设备用电量 {{ 1000 }} KW </span>
                </div>
                <div class="energy_item">
                  <span> 空调系统用电量 {{ 1000 }} KW </span>
                </div>
              </div>
              <div class="energy_row">
                <div class="energy_item">
                  <span> 照明设备用电量 {{ 1000 }} KW </span>
                </div>
                <div class="energy_item">
                  <span> 其他设备用电量 {{ 1000 }} KW </span>
                </div>
              </div>
            </div>
          </div>
          <div class="energy">
            <h4>能耗分项解析</h4>
            <div class="energy_content">
              <div id="energy-pie" style="height: 11rem; min-height: 10rem; max-height: 12rem"></div>
            </div>
          </div>
          <div class="energy">
            <h4>能耗指标</h4>
            <div class="energy_content df_center">
              <div class="gauge_out">
                <div id="energy-gauge" style="height: 13rem; min-height: 10rem; max-height: 14rem"></div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="4" v-show="active === 1">
          <div class="energy">
            <h4>负荷预测</h4>
            <div class="energy_content">
              <div
                id="energy-area1"
                style="height: 11rem; min-height: 10rem; max-height: 12rem; margin-bottom: 20px"
              ></div>
              <div id="energy-area2" style="height: 11rem; min-height: 10rem; max-height: 12rem"></div>
            </div>
          </div>
          <div class="energy">
            <h4>供水温度优化</h4>
            <div class="energy_content">
              <div id="energy-area3" style="height: 11rem; min-height: 10rem; max-height: 12rem"></div>
            </div>
          </div>
        </b-col>
        <b-col cols="4" v-show="active === 2">
          <div class="energy">
            <h4>用电量曲线</h4>
            <div class="energy_content">
              <div id="energy-line1" style="height: 11rem; min-height: 10rem; max-height: 12rem"></div>
            </div>
          </div>
          <div class="energy">
            <h4>PUE曲线</h4>
            <div class="energy_content">
              <div id="energy-line2" style="height: 11rem; min-height: 10rem; max-height: 12rem"></div>
            </div>
          </div>
        </b-col>
        <b-col cols="4" class="center_content">
          <div class="menu">
            <div class="menu_item" @click="active = 0">
              <span :class="active === 0 && 'active_color'">综合态势</span>
            </div>
            <div class="menu_item" @click="active = 1">
              <span :class="active === 1 && 'active_color'">实时数据</span>
            </div>
            <div class="menu_item" @click="active = 2">
              <span :class="active === 2 && 'active_color'">历史数据</span>
            </div>
          </div>
        </b-col>
        <b-col cols="4" v-show="active === 0">
          <div class="energy">
            <h4>节能总量</h4>
            <div class="energy_content">
              <div id="energy-column" style="height: 11rem; min-height: 10rem; max-height: 12rem"></div>
            </div>
          </div>
          <div class="energy">
            <h4>优化策略</h4>
            <div class="energy_content tableContent">
              <vue-perfect-scrollbar style="height: 36rem">
                <b-table :fields="tableColumns" :items="tableData" fixed small striped>
                  <template #cell(optimize_instruct)="data">
                    {{ data.item.optimize_instruct }}
                  </template>
                </b-table>
              </vue-perfect-scrollbar>
            </div>
          </div>
        </b-col>
        <b-col cols="4" v-show="active === 1">
          <div class="energy">
            <h4>水泵频率优化</h4>
            <div class="energy_content" style="height: 20rem"></div>
          </div>
          <div class="energy">
            <h4>启停时间优化</h4>
            <div class="energy_content" style="height: 20rem"></div>
          </div>
        </b-col>
        <b-col cols="4" v-show="active === 2"> </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import store from '@/store';
import { showToast } from '@/libs/utils/showToast';
import { computed, onMounted, reactive, ref, toRefs } from '@vue/composition-api';
import { momentJs } from '@/libs/utils/moment';
import { routerParams } from '@/libs/utils/routerParams';
import { Pie, Gauge, Column, Area, Line } from '@antv/g2plot';
import { $themeColors } from '@themeConfig';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'ProjectDetail',
  components: {
    VuePerfectScrollbar,
  },
  setup() {
    const event = reactive({
      project_id: computed(() => {
        return routerParams('project_id');
      }),
      projectInfo: computed(() => {
        return store.state.projects.selected;
      }),
      projectEnergy: {},
      projectParams: {
        current: {},
        list: {},
      },
      projectOperation: {
        alarm: [],
        inspection: [],
        repair: [],
        agent: [],
      },
      projectOptimization: {
        energy_list: [],
        prediction_list: [],
      },
    });
    const tableColumns = reactive([
      {
        label: '优化指令',
        key: 'optimize_instruct',
      },
      {
        label: '下发时间',
        key: 'issue_time',
      },
    ]);
    const tableData = reactive([
      {
        optimize_instruct: '冷凝侧出水温度   -2.5℃',
        issue_time: '2025-5-8 10:06:00',
      },
      {
        optimize_instruct: '1号冷机开启',
        issue_time: '2025-5-8 9:36:00',
      },
    ]);
    const active = ref(0);
    /**
     * 绘制饼图
     */
    const pieChartInit = () => {
      const piePlot = new Pie('energy-pie', {
        theme: {
          colors10: Object.values($themeColors),
        },
        appendPadding: [4, 4, 8, 4],
        padding: [0, 200, 0, 0],
        data: [],
        angleField: 'value',
        data: [
          {
            type: 'IT设备用电量',
            value: 36,
          },
          {
            type: 'UPS和配电',
            value: 12,
          },
          {
            type: '制冷系统',
            value: 32,
          },
          {
            type: '加湿、除湿',
            value: 15,
          },
          {
            type: '新风、照明等',
            value: 5,
          },
        ],
        colorField: 'type',
        radius: 1,
        innerRadius: 0.4,
        pieStyle: {
          lineWidth: 0,
        },
        label: {
          type: 'inner',
          offset: '-50%',
          autoRotate: false,
          style: {
            textAlign: 'center',
            fill: '#fff',
          },
          formatter: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
        },
        legend: {
          padding: [0, 100, 0, 0],
          position: 'right',
          itemName: {
            style: {
              fill: '#b8c2cc',
            },
          },
          marker: {
            symbol: 'square',
          },
        },
        statistic: {
          title: false,
          content: false,
        },
        // 添加 中心统计文本 交互
        interactions: [
          {
            type: 'element-selected',
          },
          {
            type: 'element-highlight',
          },
          {
            type: 'pie-statistic-active',
            cfg: {
              start: [
                {
                  trigger: 'element:mouseenter',
                  action: 'pie-statistic:change',
                },
                {
                  trigger: 'legend-item:mouseenter',
                  action: 'pie-statistic:change',
                },
              ],
              end: [
                {
                  trigger: 'element:mouseleave',
                  action: 'pie-statistic:reset',
                },
                {
                  trigger: 'legend-item:mouseleave',
                  action: 'pie-statistic:reset',
                },
              ],
            },
          },
        ],
      });
      piePlot.render();
      event.piePlot = piePlot;
    };
    /**
     * 绘制仪表盘
     */
    const gaugeChartInit = () => {
      const gauge = new Gauge('energy-gauge', {
        percent: 0.6,
        type: 'meter',
        innerRadius: 0.9,
        meter: {
          steps: 30,
        },
        range: {
          ticks: [0, 1 / 3, 2 / 3, 1],
          color: ['#28c76f', '#ff9f43', '#ea5455'],
        },
        axis: {
          label: {
            formatter(v) {
              return (Number(v) * 2).toFixed(2);
            },
          },
          tickLine: false,
        },
        indicator: {
          pin: {
            style: {
              r: 6,
            },
          },
        },
        statistic: {
          title: {
            formatter: ({ percent }) => {
              return percent * 2;
            },
            offsetY: 10,
            style: {
              fontSize: '20px',
              color: '#0EFF19',
            },
          },
          content: {
            offsetY: -10,
            style: {
              fontSize: '12px',
              color: '#0C59D4',
            },
            formatter: () => 'PUE',
          },
        },
      });
      gauge.render();
      event.gauge = gauge;
    };
    /**
     * 绘制柱状图
     */
    const columnChartInit = () => {
      const columnPlot = new Column('energy-column', {
        data: [
          {
            type: '1月',
            sales: 1.5,
          },
          {
            type: '2月',
            sales: 2.5,
          },
          {
            type: '3月',
            sales: 2,
          },
          {
            type: '4月',
            sales: 2.5,
          },
          {
            type: '5月',
            sales: 3.5,
          },
          {
            type: '6月',
            sales: 4,
          },
          {
            type: '7月',
            sales: 4,
          },
          {
            type: '8月',
            sales: 3.5,
          },
          {
            type: '9月',
            sales: 3,
          },
          {
            type: '10月',
            sales: 2.5,
          },
          {
            type: '11月',
            sales: 2,
          },
          {
            type: '12月',
            sales: 1.5,
          },
        ],
        xField: 'type',
        yField: 'sales',
        label: {
          // 可手动配置 label 数据标签位置
          position: 'middle', // 'top', 'bottom', 'middle',
          // 配置样式
          style: {
            fill: '#FFFFFF',
            opacity: 0.6,
          },
        },
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
        },
        meta: {
          type: {
            alias: '类别',
          },
          sales: {
            alias: '节能总量',
          },
        },
      });
      columnPlot.render();
    };
    /**
     * 绘制面积图
     */
    const areaChartInit = () => {
      const areaPlot1 = new Area('energy-area1', {
        data: [
          {
            timePeriod: '2006 Q3',
            value: 1,
          },
          {
            timePeriod: '2006 Q4',
            value: 1.08,
          },
          {
            timePeriod: '2007 Q1',
            value: 1.17,
          },
          {
            timePeriod: '2007 Q2',
            value: 1.26,
          },
          {
            timePeriod: '2007 Q3',
            value: 1.34,
          },
          {
            timePeriod: '2007 Q4',
            value: 1.41,
          },
          {
            timePeriod: '2008 Q1',
            value: 1.52,
          },
          {
            timePeriod: '2008 Q2',
            value: 1.67,
          },
          {
            timePeriod: '2008 Q3',
            value: 1.84,
          },
          {
            timePeriod: '2008 Q4',
            value: 2.07,
          },
          {
            timePeriod: '2009 Q1',
            value: 2.39,
          },
          {
            timePeriod: '2009 Q2',
            value: 2.71,
          },
          {
            timePeriod: '2009 Q3',
            value: 3.03,
          },
          {
            timePeriod: '2009 Q4',
            value: 3.33,
          },
          {
            timePeriod: '2010 Q1',
            value: 3.5,
          },
          {
            timePeriod: '2010 Q2',
            value: 3.37,
          },
          {
            timePeriod: '2010 Q3',
            value: 3.15,
          },
          {
            timePeriod: '2010 Q4',
            value: 3.01,
          },
          {
            timePeriod: '2011 Q1',
            value: 2.8,
          },
          {
            timePeriod: '2011 Q2',
            value: 2.8,
          },
          {
            timePeriod: '2011 Q3',
            value: 2.84,
          },
          {
            timePeriod: '2011 Q4',
            value: 2.75,
          },
          {
            timePeriod: '2012 Q1',
            value: 2.64,
          },
          {
            timePeriod: '2012 Q2',
            value: 2.55,
          },
          {
            timePeriod: '2012 Q3',
            value: 2.46,
          },
          {
            timePeriod: '2012 Q4',
            value: 2.45,
          },
          {
            timePeriod: '2013 Q1',
            value: 2.57,
          },
          {
            timePeriod: '2013 Q2',
            value: 2.68,
          },
          {
            timePeriod: '2013 Q3',
            value: 2.8,
          },
          {
            timePeriod: '2013 Q4',
            value: 2.89,
          },
          {
            timePeriod: '2014 Q1',
            value: 2.85,
          },
          {
            timePeriod: '2014 Q2',
            value: 2.73,
          },
          {
            timePeriod: '2014 Q3',
            value: 2.54,
          },
          {
            timePeriod: '2014 Q4',
            value: 2.32,
          },
          {
            timePeriod: '2015 Q1',
            value: 2.25,
          },
          {
            timePeriod: '2015 Q2',
            value: 2.33,
          },
          {
            timePeriod: '2015 Q3',
            value: 2.53,
          },
          {
            timePeriod: '2015 Q4',
            value: 2.74,
          },
          {
            timePeriod: '2016 Q1',
            value: 2.76,
          },
          {
            timePeriod: '2016 Q2',
            value: 2.61,
          },
          {
            timePeriod: '2016 Q3',
            value: 2.35,
          },
          {
            timePeriod: '2016 Q4',
            value: 2.11,
          },
          {
            timePeriod: '2017 Q1',
            value: 2.08,
          },
          {
            timePeriod: '2017 Q2',
            value: 2.2,
          },
          {
            timePeriod: '2017 Q3',
            value: 2.38,
          },
          {
            timePeriod: '2017 Q4',
            value: 2.59,
          },
          {
            timePeriod: '2018 Q1',
            value: 2.63,
          },
          {
            timePeriod: '2018 Q2',
            value: 2.67,
          },
          {
            timePeriod: '2018 Q3',
            value: 2.64,
          },
          {
            timePeriod: '2018 Q4',
            value: 2.5,
          },
          {
            timePeriod: '2019 Q1',
            value: 2.31,
          },
          {
            timePeriod: '2019 Q2',
            value: 2.04,
          },
          {
            timePeriod: '2019 Q3',
            value: 1.83,
          },
          {
            timePeriod: '2019 Q4',
            value: 1.71,
          },
          {
            timePeriod: '2020 Q1',
            value: 1.65,
          },
          {
            timePeriod: '2020 Q2',
            value: 1.59,
          },
          {
            timePeriod: '2020 Q3',
            value: 1.58,
          },
        ],
        xField: 'timePeriod',
        yField: 'value',
        label: {
          // 可手动配置 label 数据标签位置
          position: 'middle', // 'top', 'bottom', 'middle',
          // 配置样式
          style: {
            fill: '#FFFFFF',
            opacity: 0.6,
          },
        },
        xAxis: {
          range: [0, 1],
        },
      });
      areaPlot1.render();
      const areaPlot2 = new Area('energy-area2', {
        data: [
          {
            timePeriod: '2020 Q3',
            value: 1.58,
          },
          {
            timePeriod: '2020 Q2',
            value: 1.59,
          },
          {
            timePeriod: '2020 Q1',
            value: 1.65,
          },
          {
            timePeriod: '2019 Q4',
            value: 1.71,
          },
          {
            timePeriod: '2019 Q3',
            value: 1.83,
          },
          {
            timePeriod: '2019 Q2',
            value: 2.04,
          },
          {
            timePeriod: '2019 Q1',
            value: 2.31,
          },
          {
            timePeriod: '2018 Q4',
            value: 2.5,
          },
          {
            timePeriod: '2018 Q3',
            value: 2.64,
          },
          {
            timePeriod: '2018 Q2',
            value: 2.67,
          },
          {
            timePeriod: '2018 Q1',
            value: 2.63,
          },
          {
            timePeriod: '2017 Q4',
            value: 2.59,
          },
          {
            timePeriod: '2017 Q3',
            value: 2.38,
          },
          {
            timePeriod: '2017 Q2',
            value: 2.2,
          },
          {
            timePeriod: '2017 Q1',
            value: 2.08,
          },
          {
            timePeriod: '2016 Q4',
            value: 2.11,
          },
          {
            timePeriod: '2016 Q3',
            value: 2.35,
          },
          {
            timePeriod: '2016 Q2',
            value: 2.61,
          },
          {
            timePeriod: '2016 Q1',
            value: 2.76,
          },
          {
            timePeriod: '2015 Q4',
            value: 2.74,
          },
          {
            timePeriod: '2015 Q3',
            value: 2.53,
          },
          {
            timePeriod: '2015 Q2',
            value: 2.33,
          },
          {
            timePeriod: '2015 Q1',
            value: 2.25,
          },
          {
            timePeriod: '2014 Q4',
            value: 2.32,
          },
          {
            timePeriod: '2014 Q3',
            value: 2.54,
          },
          {
            timePeriod: '2014 Q2',
            value: 2.73,
          },
          {
            timePeriod: '2014 Q1',
            value: 2.85,
          },
          {
            timePeriod: '2013 Q4',
            value: 2.89,
          },
          {
            timePeriod: '2013 Q3',
            value: 2.8,
          },
          {
            timePeriod: '2013 Q2',
            value: 2.68,
          },
          {
            timePeriod: '2013 Q1',
            value: 2.57,
          },
          {
            timePeriod: '2012 Q4',
            value: 2.45,
          },
          {
            timePeriod: '2012 Q3',
            value: 2.46,
          },
          {
            timePeriod: '2012 Q2',
            value: 2.55,
          },
          {
            timePeriod: '2012 Q1',
            value: 2.64,
          },
          {
            timePeriod: '2011 Q4',
            value: 2.75,
          },
          {
            timePeriod: '2011 Q3',
            value: 2.84,
          },
          {
            timePeriod: '2011 Q2',
            value: 2.8,
          },
          {
            timePeriod: '2011 Q1',
            value: 2.8,
          },
          {
            timePeriod: '2010 Q4',
            value: 3.01,
          },
          {
            timePeriod: '2010 Q3',
            value: 3.15,
          },
          {
            timePeriod: '2010 Q2',
            value: 3.37,
          },
          {
            timePeriod: '2010 Q1',
            value: 3.5,
          },
          {
            timePeriod: '2009 Q4',
            value: 3.33,
          },
          {
            timePeriod: '2009 Q3',
            value: 3.03,
          },
          {
            timePeriod: '2009 Q2',
            value: 2.71,
          },
          {
            timePeriod: '2009 Q1',
            value: 2.39,
          },
          {
            timePeriod: '2008 Q4',
            value: 2.07,
          },
          {
            timePeriod: '2008 Q3',
            value: 1.84,
          },
          {
            timePeriod: '2008 Q2',
            value: 1.67,
          },
          {
            timePeriod: '2008 Q1',
            value: 1.52,
          },
          {
            timePeriod: '2007 Q4',
            value: 1.41,
          },
          {
            timePeriod: '2007 Q3',
            value: 1.34,
          },
          {
            timePeriod: '2007 Q2',
            value: 1.26,
          },
          {
            timePeriod: '2007 Q1',
            value: 1.17,
          },
          {
            timePeriod: '2006 Q4',
            value: 1.08,
          },
          {
            timePeriod: '2006 Q3',
            value: 1,
          },
        ],
        xField: 'timePeriod',
        yField: 'value',
        label: {
          // 可手动配置 label 数据标签位置
          position: 'middle', // 'top', 'bottom', 'middle',
          // 配置样式
          style: {
            fill: '#FFFFFF',
            opacity: 0.6,
          },
        },
        xAxis: {
          range: [0, 1],
        },
      });
      areaPlot2.render();
      const areaPlot3 = new Area('energy-area3', {
        data: [
          {
            Date: '2010-01',
            scales: 1998,
          },
          {
            Date: '2010-02',
            scales: 1850,
          },
          {
            Date: '2010-03',
            scales: 1720,
          },
          {
            Date: '2010-04',
            scales: 1818,
          },
          {
            Date: '2010-05',
            scales: 1920,
          },
          {
            Date: '2010-06',
            scales: 1802,
          },
          {
            Date: '2010-07',
            scales: 1945,
          },
          {
            Date: '2010-08',
            scales: 1856,
          },
          {
            Date: '2010-09',
            scales: 2107,
          },
          {
            Date: '2010-10',
            scales: 2140,
          },
          {
            Date: '2010-11',
            scales: 2311,
          },
          {
            Date: '2010-12',
            scales: 1972,
          },
          {
            Date: '2011-01',
            scales: 1760,
          },
          {
            Date: '2011-02',
            scales: 1824,
          },
          {
            Date: '2011-03',
            scales: 1801,
          },
          {
            Date: '2011-04',
            scales: 2001,
          },
          {
            Date: '2011-05',
            scales: 1640,
          },
          {
            Date: '2011-06',
            scales: 1502,
          },
          {
            Date: '2011-07',
            scales: 1621,
          },
          {
            Date: '2011-08',
            scales: 1480,
          },
          {
            Date: '2011-09',
            scales: 1549,
          },
          {
            Date: '2011-10',
            scales: 1390,
          },
          {
            Date: '2011-11',
            scales: 1325,
          },
          {
            Date: '2011-12',
            scales: 1250,
          },
          {
            Date: '2012-01',
            scales: 1394,
          },
          {
            Date: '2012-02',
            scales: 1406,
          },
          {
            Date: '2012-03',
            scales: 1578,
          },
          {
            Date: '2012-04',
            scales: 1465,
          },
          {
            Date: '2012-05',
            scales: 1689,
          },
          {
            Date: '2012-06',
            scales: 1755,
          },
          {
            Date: '2012-07',
            scales: 1495,
          },
          {
            Date: '2012-08',
            scales: 1508,
          },
          {
            Date: '2012-09',
            scales: 1433,
          },
          {
            Date: '2012-10',
            scales: 1344,
          },
          {
            Date: '2012-11',
            scales: 1201,
          },
          {
            Date: '2012-12',
            scales: 1065,
          },
          {
            Date: '2013-01',
            scales: 1255,
          },
          {
            Date: '2013-02',
            scales: 1429,
          },
          {
            Date: '2013-03',
            scales: 1398,
          },
          {
            Date: '2013-04',
            scales: 1678,
          },
          {
            Date: '2013-05',
            scales: 1524,
          },
          {
            Date: '2013-06',
            scales: 1688,
          },
          {
            Date: '2013-07',
            scales: 1500,
          },
          {
            Date: '2013-08',
            scales: 1670,
          },
          {
            Date: '2013-09',
            scales: 1734,
          },
          {
            Date: '2013-10',
            scales: 1699,
          },
          {
            Date: '2013-11',
            scales: 1508,
          },
          {
            Date: '2013-12',
            scales: 1680,
          },
          {
            Date: '2014-01',
            scales: 1750,
          },
          {
            Date: '2014-02',
            scales: 1602,
          },
          {
            Date: '2014-03',
            scales: 1834,
          },
          {
            Date: '2014-04',
            scales: 1722,
          },
          {
            Date: '2014-05',
            scales: 1430,
          },
          {
            Date: '2014-06',
            scales: 1280,
          },
          {
            Date: '2014-07',
            scales: 1367,
          },
          {
            Date: '2014-08',
            scales: 1155,
          },
          {
            Date: '2014-09',
            scales: 1289,
          },
          {
            Date: '2014-10',
            scales: 1104,
          },
          {
            Date: '2014-11',
            scales: 1246,
          },
          {
            Date: '2014-12',
            scales: 1098,
          },
          {
            Date: '2015-01',
            scales: 1189,
          },
          {
            Date: '2015-02',
            scales: 1276,
          },
          {
            Date: '2015-03',
            scales: 1033,
          },
          {
            Date: '2015-04',
            scales: 956,
          },
          {
            Date: '2015-05',
            scales: 845,
          },
        ],
        xField: 'Date',
        yField: 'scales',
        xAxis: {
          tickCount: 5,
        },
        animation: false,
        slider: {
          start: 0.1,
          end: 0.9,
          trendCfg: {
            isArea: true,
          },
        },
      });
      areaPlot3.render();
    };
    /**
     * 绘制折线图
     */
    const lineChartInit = () => {
      const linePlot1 = new Line('energy-line1', {
        data: [
          {
            Date: '2010-01',
            scales: 1998,
          },
          {
            Date: '2010-02',
            scales: 1850,
          },
          {
            Date: '2010-03',
            scales: 1720,
          },
          {
            Date: '2010-04',
            scales: 1818,
          },
          {
            Date: '2010-05',
            scales: 1920,
          },
          {
            Date: '2010-06',
            scales: 1802,
          },
          {
            Date: '2010-07',
            scales: 1945,
          },
          {
            Date: '2010-08',
            scales: 1856,
          },
          {
            Date: '2010-09',
            scales: 2107,
          },
          {
            Date: '2010-10',
            scales: 2140,
          },
          {
            Date: '2010-11',
            scales: 2311,
          },
          {
            Date: '2010-12',
            scales: 1972,
          },
          {
            Date: '2011-01',
            scales: 1760,
          },
          {
            Date: '2011-02',
            scales: 1824,
          },
          {
            Date: '2011-03',
            scales: 1801,
          },
          {
            Date: '2011-04',
            scales: 2001,
          },
          {
            Date: '2011-05',
            scales: 1640,
          },
          {
            Date: '2011-06',
            scales: 1502,
          },
          {
            Date: '2011-07',
            scales: 1621,
          },
          {
            Date: '2011-08',
            scales: 1480,
          },
          {
            Date: '2011-09',
            scales: 1549,
          },
          {
            Date: '2011-10',
            scales: 1390,
          },
          {
            Date: '2011-11',
            scales: 1325,
          },
          {
            Date: '2011-12',
            scales: 1250,
          },
          {
            Date: '2012-01',
            scales: 1394,
          },
          {
            Date: '2012-02',
            scales: 1406,
          },
          {
            Date: '2012-03',
            scales: 1578,
          },
          {
            Date: '2012-04',
            scales: 1465,
          },
          {
            Date: '2012-05',
            scales: 1689,
          },
        ],
        padding: 'auto',
        xField: 'Date',
        yField: 'scales',
        xAxis: {
          // type: 'timeCat',
          tickCount: 5,
        },
      });
      linePlot1.render();
      const linePlot2 = new Line('energy-line2', {
        data: [
          {
            Date: '2012-05',
            scales: 1689,
          },
          {
            Date: '2012-04',
            scales: 1465,
          },
          {
            Date: '2012-03',
            scales: 1578,
          },
          {
            Date: '2012-02',
            scales: 1406,
          },
          {
            Date: '2012-01',
            scales: 1394,
          },
          {
            Date: '2011-12',
            scales: 1250,
          },
          {
            Date: '2011-11',
            scales: 1325,
          },
          {
            Date: '2011-10',
            scales: 1390,
          },
          {
            Date: '2011-09',
            scales: 1549,
          },
          {
            Date: '2011-08',
            scales: 1480,
          },
          {
            Date: '2011-07',
            scales: 1621,
          },
          {
            Date: '2011-06',
            scales: 1502,
          },
          {
            Date: '2011-05',
            scales: 1640,
          },
          {
            Date: '2011-04',
            scales: 2001,
          },
          {
            Date: '2011-03',
            scales: 1801,
          },
          {
            Date: '2011-02',
            scales: 1824,
          },
          {
            Date: '2011-01',
            scales: 1760,
          },
          {
            Date: '2010-12',
            scales: 1972,
          },
          {
            Date: '2010-11',
            scales: 2311,
          },
          {
            Date: '2010-10',
            scales: 2140,
          },
          {
            Date: '2010-09',
            scales: 2107,
          },
          {
            Date: '2010-08',
            scales: 1856,
          },
          {
            Date: '2010-07',
            scales: 1945,
          },
          {
            Date: '2010-06',
            scales: 1802,
          },
          {
            Date: '2010-05',
            scales: 1920,
          },
          {
            Date: '2010-04',
            scales: 1818,
          },
          {
            Date: '2010-03',
            scales: 1720,
          },
          {
            Date: '2010-02',
            scales: 1850,
          },
          {
            Date: '2010-01',
            scales: 1998,
          },
        ],
        padding: 'auto',
        xField: 'Date',
        yField: 'scales',
        xAxis: {
          // type: 'timeCat',
          tickCount: 5,
        },
      });
      linePlot2.render();
    };
    const getProjectInfo = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProject', project_id)
        .then((response) => {
          event.projectInfo = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };
    const getProjectEnergy = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectEnergy', project_id)
        .then((response) => {
          event.projectEnergy = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };
    const getProjectParams = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectParams', project_id)
        .then((response) => {
          event.projectParams = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };
    const getProjectOperation = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectOperation', project_id)
        .then((response) => {
          event.projectOperation = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };
    const getProjectOptimization = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectOptimization', project_id)
        .then((response) => {
          console.log('OptimizationData', response.data);
          event.projectOptimization = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };
    onMounted(() => {
      pieChartInit();
      gaugeChartInit();
      columnChartInit();
      areaChartInit();
      lineChartInit();

      getProjectEnergy();
      getProjectParams();
      getProjectOperation();
      setTimeout(() => {
        // getProjectInfo();
        getProjectOptimization();
      }, 2000);
    });
    return {
      ...toRefs(event),
      momentJs,
      tableColumns,
      tableData,
      active,
    };
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss" scoped>
.section_row {
  height: 65rem;
}
.energy {
  background-color: #293047;
  margin-bottom: 2rem;
  border-radius: 0.428rem;
  padding: 1.5rem;
  h4 {
    background-color: #0066cc;
    padding: 8px;
    border: 4px solid #0e3d71;
  }
  .energy_content {
    margin-top: 1.5rem;
    margin-bottom: -0.5rem;
    padding: 0 10px;
    .energy_row {
      display: flex;
      justify-content: space-between;
      .energy_item {
        width: 45%;
        border: 2px solid #387dd7;
        display: flex;
        padding: 7px;
        margin-bottom: 1.5rem;
      }
    }
    .gauge_out {
      width: 20rem;
      padding: 10px;
      margin-top: -5px;
      background-color: #051633;
    }
  }
  .df_center {
    display: flex;
    justify-content: center;
  }
  .tableContent {
    height: 36rem;
  }
  .table {
  }
}
.center_content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 20px;
    .menu_item {
      font-size: 24px;
      cursor: pointer;
      .active_color {
        color: #ffff37;
      }
    }
  }
}
</style>
